
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link as ScrollLink } from "react-scroll";
import { Link } from "react-router-dom";
interface ChallengeActionsProps {
  isCompleted?: boolean;
}
export const ChallengeActions: React.FC<ChallengeActionsProps> = ({
  isCompleted = false
}) => {
  return <div className="flex flex-col md:flex-row gap-3">
      {isCompleted ? <>
          <Button size="lg" asChild>
            <ScrollLink to="derivatives" spy={true} smooth={true} offset={-100} duration={500} className="cursor-pointer">
              Voir les créations
              <ArrowRight className="ml-2 h-4 w-4" />
            </ScrollLink>
          </Button>
          
          <Button variant="outline" size="lg" asChild>
            <ScrollLink to="statistics" spy={true} smooth={true} offset={-100} duration={500} className="cursor-pointer">
              Consulter les statistiques
              <ArrowRight className="ml-2 h-4 w-4" />
            </ScrollLink>
          </Button>
        </> : <>
          <Button size="lg" asChild>
            <Link to="/about">
              En savoir plus
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
          
          <Button variant="outline" size="lg" asChild>
            <ScrollLink to="participation" spy={true} smooth={true} offset={-100} duration={500} className="cursor-pointer">
              Comment participer
              <ArrowRight className="ml-2 h-4 w-4" />
            </ScrollLink>
          </Button>
        </>}
    </div>;
};
